export default __webpack_public_path__ + "static/media/pokemon.524e767f.png";